import { countryType, currencySymbol } from 'utils/Constants';

export function CurrencyFormater(num: number | string): string | number {
  if (num) {
    const formattedCurrency = num?.toLocaleString(countryType.EURO, {
      minimumFractionDigits: 7,
      maximumFractionDigits: 7,
    });
    return formattedCurrency && currencySymbol.EURO + ' ' + formattedCurrency;
  } else {
    return `${currencySymbol.EURO}${' '}${Number(0.0).toFixed(7)}`;
  }
}

export function FundUnitFormater(num: number | string): string | number {
  return Number(num).toFixed(7);
}

export function CurrencyFormaterTwoDecimals(
  num: number | string,
): string | number {
  if (num) {
    const formattedCurrency = num?.toLocaleString(countryType.EURO, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return formattedCurrency && currencySymbol.EURO + ' ' + formattedCurrency;
  } else {
    return `${currencySymbol.EURO}${' '}${Number(0.0).toFixed(2)}`;
  }
}

export function CurrencyFormatterAllDecimals(
  num: number | string,
): string | number {
  if (num && Number(num) > 0) {
    const numericValue = Number(num);
    const decimalPart = numericValue.toString().split('.')[1];
    const formattedCurrency = numericValue.toLocaleString(countryType.EURO, {
      minimumFractionDigits: 0,
      maximumFractionDigits: decimalPart ? decimalPart.length : 0,
    });
    return currencySymbol.EURO + ' ' + formattedCurrency;
  } else {
    return `${currencySymbol.EURO} 0.00`;
  }
}
